import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  text: {
    color: 'var(--text-primary)',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '23.43px',
    width: '630px',
  },

  paymentFailed: {
    '& .text': {
      maxWidth: '540px',
    },
  },

  button: {
    margin: '0 0 0 11px',
  },
}));

export default useStyles;
